import { createContext } from 'react';
import { SubscriptionState } from '@common/types/subscription';

const SubscriptionContext = createContext<SubscriptionState>({
  isLoading: false,
});

export default SubscriptionContext;
